import PropTypes from 'prop-types'
import React from 'react'
import InfoSVG from 'component/svgComponents/info'
import errorIcon from 'images/irc-error.svg'

const SupplyItemsNotFoundBox = ({
    items,
    topMsg,
    error = false,
    bottomMsg,
    showRetryButton = false,
    onRetry = null,
    retryLoading = false,
    translate = null,
  }) => (
    <>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    <div style={{background: error && "#fce9ea", borderColor: error && "#b42a27", height: !error && "106px", gap: error && '5px', position: 'relative'}} className='supply-items-not-found-box'>
      {error ?  <img className='supply-items-icon' width={20} height={20} src={errorIcon} /> : <InfoSVG className='supply-items-icon'/>}
      <div style={{justifyContent: error && "space-between"}} className='supply-info' >
        <span className='top-msg'> <b>{error ? "Falha" : "Atenção"}! </b> {topMsg} </span>
        <span style={{fontWeight: '600'}}> {items.join(", ")}</span>
        <span style={{paddingBottom: error && 0}} className='bottom-msg'> {bottomMsg} </span>
      </div>
      {showRetryButton && onRetry && (
        <div 
          onClick={retryLoading ? undefined : onRetry}
          style={{
            position: 'absolute',
            right: '12px',
            top: '12px',
            cursor: retryLoading ? 'not-allowed' : 'pointer',
            padding: '4px',
            borderRadius: '4px',
            backgroundColor: 'transparent',
            border: '1px solid #d4d4d4',
            transition: 'all 0.15s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '24px',
            height: '24px',
            opacity: retryLoading ? 0.6 : 0.8
          }}
          onMouseEnter={(e) => {
            if (!retryLoading) {
              e.target.style.backgroundColor = '#f8f9fa';
              e.target.style.borderColor = '#999';
              e.target.style.opacity = '1';
            }
          }}
          onMouseLeave={(e) => {
            if (!retryLoading) {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = '#d4d4d4';
              e.target.style.opacity = '0.8';
            }
          }}
              title={retryLoading ? 'Processando...' : (translate ? translate('price.banner.retry.failed.products') : 'Tentar novamente apenas estes LMs')}
        >
          {retryLoading ? (
            <span style={{
              width: '12px',
              height: '12px',
              border: '2px solid #f0f0f0',
              borderTop: '2px solid #666',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }}></span>
          ) : (
            <span style={{
              fontSize: '12px',
              color: '#666',
              transform: 'rotate(0deg)',
              transition: 'transform 0.2s ease'
            }}>↻</span>
          )}
        </div>
      )}

    </div>
    </>
  )
  
  SupplyItemsNotFoundBox.propTypes = {
    items: PropTypes.array.isRequired,
    topMsg: PropTypes.string.isRequired,
    bottomMsg: PropTypes.string.isRequired,
    error: PropTypes.bool,
    showRetryButton: PropTypes.bool,
    onRetry: PropTypes.func,
    retryLoading: PropTypes.bool,
    translate: PropTypes.func,
  }
  
  export default SupplyItemsNotFoundBox